import React, { Component } from 'react'
import withTranslationWrapper from '../../HOC/HocTranslate'
import SimpleModalWrapped from '../common/Modal'
import TextField from '../common/TextField'
import SingleSelect from '../common/SingleSelect'
import { withStyles } from '@mui/styles'
import Grid from '@mui/material/Grid'
import { FormControlLabel } from '@mui/material'
import Switch from '../common/Switch'

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dense: {
    marginTop: 19
  },
  menu: {
    width: 200
  },
  button: {
    margin: theme.spacing(1)
  }
})

class AddDeviceModelModal extends Component {
  render () {
    const { form, isEdit, protocols } = this.props
    const protocolOptions = protocols || []
    const protocolLabel = this.props.translate('protocol')
    const selectProtocolLabel = `Select ${protocolLabel}`
    const Content = (
      <div>
        <Grid container spacing={4}>
          <Grid item md={4} sm={6} xs={12}>
            <TextField
              id='name'
              label={this.props.translate('sharedName')}
              type='text'
              placeholder=''
              value={(form && form.name) || ''}
              onChange={this.props.handleChange('name')}
              variant='outlined'
              margin='dense'
              fullWidth
              required
            />
          </Grid>
          <Grid item md={4} sm={6} xs={12} style={{ position: 'relative', zIndex: 9999 }}>
            <SingleSelect
              array={protocolOptions}
              selectName='protocol'
              isClearable={!isEdit}
              isSearchable
              canAssign
              isDisabled={!!isEdit}
              label={protocolLabel}
              menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
              menuPosition='fixed'
              styles={{
                menuPortal: base => ({ ...base, zIndex: 99999 }),
                menu: base => ({ ...base, zIndex: 99999 })
              }}
              value={
                form && form.protocol
                  ? {
                      id: form.protocol,
                      key: form.protocol,
                      name: form.protocol,
                      label: form.protocol,
                      value: form.protocol
                    }
                  : {
                      key: selectProtocolLabel,
                      id: selectProtocolLabel,
                      label: selectProtocolLabel
                    }
              }
              handleChange={this.props.handleProtocolChange}
            />
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <TextField
              id='port'
              label={this.props.translate('port')}
              type='number'
              placeholder=''
              value={(form && form.port) || ''}
              onChange={this.props.handleChange('port')}
              variant='outlined'
              margin='dense'
              fullWidth
              required
              disabled={!!isEdit}
            />
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <FormControlLabel
              style={{ marginTop: 8, marginLeft: 0 }}
              control={
                <Switch
                  checked={form && form.status === 2}
                  onChange={this.props.handleStatusChange}
                />
              }
              label={
                form && form.status === 2
                  ? this.props.translate('enabled')
                  : this.props.translate('disabled')
              }
              labelPlacement='end'
              classes={{ label: 'color-inherit' }}
            />
          </Grid>
        </Grid>
        <br />
      </div>
    )
    return (
      <div>
        <SimpleModalWrapped
          visable={true}
          isButtonVisable={true}
          title={this.props.translate(isEdit ? 'editDeviceModel' : 'addDeviceModel')}
          formSubmit={this.props.formSubmit}
          modalControle={this.props.modalControle}
          btnclosetext={this.props.translate('sharedBack')}
          content={Content}
          buttonText={this.props.buttonText}
          isVisableBtn={this.props.isVisableBtn}
          attributeChangesMessage={this.props.attributeChangesMessage}
        />
      </div>
    )
  }
}

const StyledModal = withStyles(styles)
export default StyledModal(withTranslationWrapper(AddDeviceModelModal))
